.a7{width:100%;}